/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import { CloseIcon } from "../assets/icons";


export const imagetype = ["png", "jpg", "jpeg","PNG","gif","webp","jfif"];
export const filetype = ["docx","doc", "xlsx", "pdf", "txt","pptx"];

function FileFullView({visible, onClose, path,refreshData }) {
  let type = path?.split(".").reverse()[0];
  let ImgName = path?.split("/").reverse()[0];
  const handleOnClose = (e) => {
    refreshData&& refreshData();
    if (e.target.id === "modal") onClose();
  };
  if (!visible) return null;
  return (
    <div
      id="modal"
      onClick={handleOnClose}
      className="bg-black bg-opacity-30 fixed inset-0 backdrop-blur-sm 
    flex justify-center items-center z-10"
    >
      <div className="bg-white p-2 rounded w-[97%] h-[calc(100vh-30px)] ">
        <div className="flex items-start justify-between px-5 py-2  rounded-t">
          <h3 className="text-xs 2xl:text-sm font-semibold">
            {/* {data.filePath ? data?.filePath: data?.name} */}
            {ImgName}
          </h3>
          <span
            className="h-6 w-6 text-2xl block cursor-pointer"
            onClick={onClose}
          >
            <CloseIcon/>
          </span>
        </div>
        <div className=" overflow-x-hidden overflow-y-auto h-[calc(100vh-85px)]">
          {filetype?.includes(type) ? (
            <iframe 
              src={path}
              width="100%" height="100%" type="text">
              </iframe>
            
          ) : null}
          {imagetype?.includes(type) ? (
            <div className=" w-full h-[calc(100vh-85px)] overflow-hidden flex justify-center items-center">
            <img
            //  height="100%"
             width="auto"
             src={path}
              className=' max-h-[calc(100vh-85px)]'
              alt="file not found"
            />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default FileFullView;
